<mark class="ic-block"> </mark> <mark class="indicator"> </mark>
<div class="content"><ng-content /></div>
